// extracted by mini-css-extract-plugin
export default {"ScreenXSMax":"(max-width: 767px)","size":"125px","ingredient":"G662444 G41b766","imageContainer":"G792f0b","loadingSkeleton":"Gd3e8c3","loading-skeleton":"Gcb1522"};